// extracted by mini-css-extract-plugin
module.exports = {"affiliateBox":"BuyBook_affiliateBox__sJ1gQ","seller":"BuyBook_seller__0QSiF","sellerLogo":"BuyBook_sellerLogo__LZDJO"};